import React from 'react'
import { CommonContext } from '@ssr/context'
import Meta from './Meta'
import AnalyticsApp from '../Analytics/AnalyticsApp'
import Init from './Init'
import RumLogger from '../Logger/RumLogger'

export default function BaseLayout({ children }) {
  const { locale, isCN, isDev } = React.useContext(CommonContext)

  return (
    <>
      <Meta />
      {children}
      <Init />
      <AnalyticsApp />
      {!isDev ? (
        <>
          <RumLogger locale={locale} location={isCN ? 'CN' : 'US'} />
        </>
      ) : null}
    </>
  )
}
